"use client";

import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";

import { cn } from "./utils";

const RadixSeparator = SeparatorPrimitive as any;
const SeparatorRoot = (RadixSeparator as any)?.Root ?? RadixSeparator;
const hasRadixSeparator = typeof SeparatorRoot !== "undefined";

let hasWarnedMissingRadixSeparator = false;
const warnMissingRadixSeparator = () => {
  if (hasWarnedMissingRadixSeparator) return;
  hasWarnedMissingRadixSeparator = true;
  console.warn(
    "[ui/separator] Radix Separator primitives unavailable. Falling back to basic markup.",
  );
};

function Separator({
  className,
  orientation = "horizontal",
  decorative = true,
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root>) {
  const { asChild, _fgT, _fgt, _fgS, _fgs, _fgB, _fgb, ...rest } = props as any;
  if (!hasRadixSeparator) {
    warnMissingRadixSeparator();
    return (
      <div
        data-slot="separator-fallback"
        role={decorative ? "presentation" : "separator"}
        aria-orientation={orientation}
        className={cn(
          "bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px",
          className,
        )}
        {...rest}
      />
    );
  }
  const Root = SeparatorRoot as typeof SeparatorPrimitive.Root;
  const { _fgT: _1, _fgt: _2, _fgS: _3, _fgs: _4, _fgB: _5, _fgb: _6, ...cleanProps } = props as any;
  
  return (
    <Root
      data-slot="separator-root"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        "bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px",
        className,
      )}
      {...cleanProps}
    />
  );
}

export { Separator };
